import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useUIStore } from '@/store/uiStore'
import { cn } from '@/lib/utils'

const pageTitles: Record<string, { title: string; subtitle?: string }> = {
  '/': { title: 'Dashboard', subtitle: 'Sales Agent Overview' },
  '/leads': { title: 'Leads', subtitle: 'Manage your leads' },
  '/activities': { title: 'Activities', subtitle: 'Track all activities' },
  '/conversations': { title: 'Conversations', subtitle: 'View all conversations' },
  '/prompts': { title: 'Prompts', subtitle: 'Manage AI prompts' },
  '/knowledge': { title: 'Knowledge Base', subtitle: 'AI knowledge management' },
  '/inbound': { title: 'Inbound Numbers', subtitle: 'Phone configuration' },
  '/voices': { title: 'Voice Library', subtitle: 'Browse and configure AI voices' },
  '/scout': { title: 'Scout', subtitle: 'Lead scouting configuration' },
  '/users': { title: 'User Management', subtitle: 'Manage users and roles' },
}

interface MainLayoutProps {
  onLogout?: () => void
}

export function MainLayout({ onLogout }: MainLayoutProps) {
  const location = useLocation()
  const { sidebarCollapsed } = useUIStore()

  // Get page info based on current path
  const getPageInfo = () => {
    const path = location.pathname
    // Check for exact match first
    if (pageTitles[path]) return pageTitles[path]
    // Check for partial matches (e.g., /leads/123)
    for (const [key, value] of Object.entries(pageTitles)) {
      if (key !== '/' && path.startsWith(key)) return value
    }
    return { title: 'Sales AI', subtitle: 'Multi-Agent AI System' }
  }

  const pageInfo = getPageInfo()

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <div
        className={cn(
          'flex flex-col transition-all duration-300',
          sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-64'
        )}
      >
        <Header
          title={pageInfo.title}
          subtitle={pageInfo.subtitle}
          onLogout={onLogout}
        />
        <main className="flex-1 p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
